import { Environment } from '../../const/environment';
import { ProjectViewMode } from '../../const/projectViewMode';

const plans = {
    'free': {
        environments: [Environment.Staging],
        modes: [ProjectViewMode.Edit]
    }
};

const defaultPlan = {
    environments: [Environment.Staging, Environment.Testing, Environment.Production],
    modes: [ProjectViewMode.Edit, ProjectViewMode.Test]
};

export default function getAvailableFeatures(plan) {
    return plans[plan] || defaultPlan;
}
